import { reactive, computed, watch } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import * as apiQA from '@/api/qa'
import * as apiBookmark from '@/api/bookmark'
import * as apiCommon from '@/api/common'
import * as _ from 'lodash'
import { gtmLog } from '@/util/log'
import { SCROLL_INTERVAL_DELAY, SCROLL_INTERVAL_MAX_COUNT } from '@/util/constants'

/**
 * QA詳細画面
 */
export const getGroup = (props, context) => {

  // ローカルストレージに保存するためのキー名（管理システムの書籍プレビュー専用）
  const LOCAL_STORAGE_KEY_QA_NEW_WINDOW = 'PARAMS_QA_NEW_WINDOW'

  // URLのQA IDを監視する
  watch(() => props.qaId, (newVal, oldVal) => {
    if (oldVal) {

      store.dispatch('qa/setQaId', newVal)

      // ※目次エリアはツリーの開閉情報維持のためリロードしない
      // 目次スクロール位置指定用QAIDを設定
      group1.scrollTopQAID = store.state.qa.qaId

      // 目次スクロール位置指定用QAIDの位置に目次を移動
      group1.scrollTableOfContentsAreaToCurrentQA()

      // 本文（メインエリア）を更新
      group1.updateMainArea()

      // 関連情報（右サイドエリア）を更新
      group1.updateBookExampleRelatedArea()

    }
  })
  
  const group1 = reactive({
    
    // ### ヘッダエリア ###
    manualRecomentation: '', // 追録号数(フロントエンドログイン時に表示）
    manualRecomentationDisp: computed(() => {
      return (group1.manualRecomentation === '') ? '-' : group1.manualRecomentation
    }),

    search_text: '', // キーワード入力欄に入力した文字列

    // 関連情報存在フラグ
    relatedInfoExists: false,
    // 内容現在存在フラグ
    relatedContentsExist: false,
    // 書式ダウンロード存在フラグ
    formDownloadsExist: false,
    // 書籍情報表示フラグ
    isAboutBookShown: false,

    // 目次エリア印刷可能フラグ
    isTableOfContentsAreaPrintable: false,
    // 本文（メインエリア）印刷可能フラグ
    isMainAreaPrintable: false,
    // 関連情報（右サイドエリア）印刷可能フラグ
    isBookExampleRelatedAreaPrintable: false,
    
    // ### 目次エリア ###
    // 目次全画面表示フラグ
    isFullSizeNavigation: false,

    tableOfContentsAreaTreeData: {}, // 書籍目次ツリーデータ

    // 目次のドリルダウン表示制御（SP用）
    parentId: -1, // 親階層のID(SP用)：ルートの場合、親が無いので-1
    currentId: 0,
    currentTitleFirstLine: '', // 現在の階層のタイトル1行目(SP用)
    currentTitleAfterSecondLines: [], // 現在の階層のタイトル2行目以降(SP用)
    currentTableOfContents: [], // 現在の階層の目次リスト(SP用)

    // データロード完了フラグ
    isListBookTableOfContentsLoaded: false,

    // 書籍名
    bookTitle: computed(() => {
      return store.state.qa.bookName
    }),

    // QAID
    qaId: computed(() => {
      return store.state.qa.qaId
    }),
    // QAタイトル
    qaTitle: '',

    // QAコード
    qaCode: '',

    // ### 本文エリア ###
    // 設問詳細タイプ（2:QA 3:あらまし）
    type: 0,

    // PDFのURL(ダウンロード用)
    pdfURLDownload: '',
    // PDFのURL(埋め込みURL用)
    pdfURLStatic: '',

    // あらまし
    contents: '',

    // 本文データロード完了フラグ
    isMainContentsLoaded: false,

    // ### 関連情報エリア ###
    related_laws: [], // 関連法令
    related_precedents: [], // 関連判例
    related_decisions: [], // 関連裁決
    related_notifications: [], // 関連通達

    // 関連情報データロード完了フラグ
    isListBookExampleRelatedInfoLoaded: false,

    // ### 書籍情報表示用 ###
    book_author: '',
    book_manual_recomentation: '',
    book_publication_date: '',

    // 関連情報ウィンドウ表示フラグ
    visibleRelatedData: computed({
      get: () => {
        return store.state.qaRelatedInfo.visibleRelatedData
      },
      set: (value) => {
        store.dispatch('qaRelatedInfo/setVisibleRelatedData', value)
      }
    }),
    // 新旧対照表ウィンドウ表示フラグ
    visibleOldAndNewMappings: computed({
      get: () => {
        return store.state.qaRelatedInfo.visibleOldAndNewMappings
      },
      set: (value) => {
        store.dispatch('qaRelatedInfo/setVisibleOldAndNewMappings', value)
      }
    }),

    // ### その他 ###
    // ブックマークフラグ
    isBookmarked: false,
    // ブックマークID
    bookmarksId: 0,

    // フロントエンドログインフラグ（管理システムから遷移してきた場合）
    isFrontendLogin: computed(() => {
      return (store.state.profile.login_type === 2) 
    }),
    // フロントエンドログイン情報表示欄の高さ
    frontendLoginInfoAreaHeight: computed(() => {
      return (group1.isFrontendLogin) ? 50 : 0 
    }),

    // 書籍プレビューフラグ(QA詳細の目次切り替えでページを描画しなおすためストアの値を使用する)
    isBookPreview: computed(() => {
      // 現在の画面名(/router/index.jsのrouter.beforeEach()メソッド内でストアに保存された値)
      const toName = store.state.common.toName
      return (toName === 'PCQADetailPreview')
    }),

    // 目次スクロール位置指定用QAID
    scrollTopQAID: 0,

    // 現在のリビジョン名
    revisionName: computed(() => {
      // if (store.state.qa.searchIndexId === 0) {
      //   return '最新'
      // } else {
      return store.state.qa.revisionName
      // }
    }),

    /**
     * GTMにログを送信する
     */
    sendGtmLog: (bookCode, qaCode, productCodes) => {
      const productIdsStr = productCodes.join(',')

      // GTMパラメータ
      const extraParams = {
        'book-id': bookCode,
        'qa-code': qaCode,
        'product-ids': productIdsStr
      }
      gtmLog('ga-qa-detail-user-log', extraParams)
    },

    /**
     * リビジョンの切り替え
     * 過去の事例を見るのsubmitボタンを押した場合
     */
    changeRevision: (qaId) => {

      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPQADetail', params: { qaId: qaId } }).catch(() => {})
      } else {
        router.push({ name: 'PCQADetail', params: { qaId: qaId } }).catch(() => {})
      }

      // 初期表示
      group1.init()
    },

    /**
     * 初期表示
     */
    init: () => {
      
      // 初期化
      store.dispatch('qa/setRevisionName', '')

      // 目次エリア印刷可能フラグ
      group1.isTableOfContentsAreaPrintable = false
      // 本文（メインエリア）印刷可能フラグ
      group1.isMainAreaPrintable = false
      // 関連情報（右サイドエリア）印刷可能フラグ
      group1.isBookExampleRelatedAreaPrintable = false

      if (
        store.state.common.device === 'pc' &&
        (!_.isNaN(props.bookId) && props.bookId !== 0 &&
        !_.isNaN(props.bookRevisionId) && props.bookRevisionId !== 0 &&
        !_.isNaN(props.qaId) && props.qaId !== 0)
      ) {
        // 管理システムの書籍プレビューの場合
        // 【仕様】
        // 「/lc/app/pc/qa-detail/{書籍ID}/{書籍リビジョンID}/{QAID}」のURLでアクセスした場合は、
        // 管理システムの書籍プレビューであると判断する
        store.dispatch('qa/setBookId', 0) // 後に記述しているQAIDから書籍情報を取得する処理を実行するため書籍IDは0に設定しておく
        store.dispatch('qa/setBookName', '')
        store.dispatch('qa/setQaId', props.qaId)
        store.dispatch('qa/setSearchIndexId', 0) // 検索インデックスは初期表示は最新にしておく
        store.dispatch('qa/setNumberCarouselVisible', 0)
        store.dispatch('qa/setBookRevisionId', props.bookRevisionId) // 書籍リビジョンID(書籍プレビュー時に非公開リビジョンを取得するために利用)
      } else if (
        !_.isNaN(props.qaId) && props.qaId !== 0
      ) {
        // QAIDを指定したURLで直接アクセスした場合、または別ウィンドウ表示した場合
        store.dispatch('qa/setBookId', 0) // 後に記述しているQAIDから書籍情報を取得する処理を実行するため書籍IDは0に設定しておく
        store.dispatch('qa/setBookName', '')
        store.dispatch('qa/setQaId', props.qaId)
        store.dispatch('qa/setSearchIndexId', 0) // 検索インデックスは初期表示は最新にしておく
        store.dispatch('qa/setNumberCarouselVisible', 0)

        // 書籍リビジョンIDは、ローカルストレージ経由で値が渡された場合は、その値を設定する。それ以外は0を設定する
        let bookRevisionId = 0
        try {
          // 別ウィンドウ表示で書籍リビジョンIDが渡された場合
          const json = localStorage.getItem(LOCAL_STORAGE_KEY_QA_NEW_WINDOW)
          if (json) {
            const data = JSON.parse(json)
            if (typeof data.bookRevisionId !== 'undefined') {
              // ローカルストレージ経由で値が渡された場合
              bookRevisionId = data.bookRevisionId
            }
          }
        } catch (e) {
        }
        store.dispatch('qa/setBookRevisionId', bookRevisionId)
      } else {
        // デフォルトの遷移
        store.dispatch('qa/setBookRevisionId', 0)
      }

      // 別ウィンドウ表示のパラメータ渡し用に使われたローカルストレージの値をクリア
      localStorage.removeItem(LOCAL_STORAGE_KEY_QA_NEW_WINDOW)

      // 目次スクロール位置指定用QAIDを設定
      group1.scrollTopQAID = store.state.qa.qaId

      if (store.state.qa.bookId === 0) {
        // 書籍IDが0の場合（直接アクセスした場合、書籍一覧、書式DL画面のQAタイトルをクリックしてアクセスした場合）

        // QA IDから書籍IDを取得するために書籍情報取得APIをコール
        const params = {}
        params.qa_id = store.state.qa.qaId
        params.search_index_id = 0 // 検索インデックスは指定する必要ないので最新にしておく

        apiQA.fetchBookInfo(params)
          .then(response => {
            if (response) {
              const { data } = response

              // 書籍IDをstoreに保存
              store.dispatch('qa/setBookId', data.book_id)
              store.dispatch('qa/setBookName', data.book_name)

              // リビジョン表示部に現在のリビジョンを表示(初期処理用)
              group1.updateCurrentRevisionForInit()
            }
          })
      } else {
        // 書籍IDが設定されている場合（QA一覧から遷移してきた場合）

        // リビジョン表示部に現在のリビジョンを表示(初期処理用)
        group1.updateCurrentRevisionForInit()
      }
    },

    /**
     * リビジョン表示部に現在のリビジョンを表示(初期処理用)
     */
    updateCurrentRevisionForInit: async () => {

      // 初期化
      store.dispatch('qa/setSearchIndexId', 0)
      store.dispatch('qa/setRevisionName', '') // 「最新」を設定すると、一瞬表示されてしまうので空文字にしておく

      // リビジョン一覧API（リビジョン切替用）をコール
      const params = {}
      params.book_id = store.state.qa.bookId
      params.qa_id = store.state.qa.qaId

      await apiQA.listRevisionsForChange(params)
        .then(async (response) => {
          if (response) {
            const { data } = response

            // 最新のQAID
            const lastestQaId = data.qa_id

            const packages = data.packages ?? []

            // 現在選択しているQA ID
            const selectedQaId = store.state.qa.qaId

            if (lastestQaId === selectedQaId) {
              // 最新のQAIDの場合
              await store.dispatch('qa/setSearchIndexId', 0)
              await store.dispatch('qa/setRevisionName', '最新')
            } else {
              let isFound = true
              for (let i = 0; i < packages.length; i++) {
                const revisions = packages[i].revisions
                for (let k = 0; k < revisions.length; k++) {
                  const searchIndexId = revisions[k].id
                  const qaId = revisions[k].qa_id
                  const name = revisions[k].name
                  if (qaId === selectedQaId) {
                    await store.dispatch('qa/setSearchIndexId', searchIndexId)
                    await store.dispatch('qa/setRevisionName', name)
                    isFound = true
                    break
                  }
                }
                if (isFound) {
                  break
                }
              }
            }

            // 各エリアを更新
            group1.updateAllArea()
          }
        })
    },

    /**
     * 各エリアを更新
     */
    updateAllArea: () => {

      // 目次エリアを更新
      group1.updateTableOfContentsArea()

      // 本文（メインエリア）を更新
      group1.updateMainArea()

      // 関連情報（右サイドエリア）を更新
      group1.updateBookExampleRelatedArea()
    },

    /**
     * 目次エリアを更新
     */
    updateTableOfContentsArea: () => {
      
      // 書籍目次一覧APIをコール
      const params = {}
      params.book_id = store.state.qa.bookId
      params.search_index_id = store.state.qa.searchIndexId
      if (group1.isBookPreview) {
        // 書籍プレビューの場合
        // 書籍リビジョンID(書籍プレビュー時に非公開リビジョンを取得するために利用)
        params.book_revision_id = store.state.qa.bookRevisionId
      }

      group1.isListBookTableOfContentsLoaded = false

      apiQA.listBookTableOfContents(params)
        .then(response => {
          if (response) {
            const { data } = response

            const listWork = data.list ?? []

            const treeData = {
              id: 0,
              title: '',
              children: listWork,
              isOpen: true,
              parent: null
            }

            // ツリーの要素に拡張項目を追加する
            group1.addExtraParamsToTreeData(treeData, null, store.state.qa.qaId)

            group1.tableOfContentsAreaTreeData = treeData

            // 現在の階層の書籍情報を設定
            group1.parentId = -1
            group1.currentId = 0
            group1.currentTitleFirstLine = group1.bookTitle
            group1.currentTitleAfterSecondLines = []
            group1.currentTableOfContents = treeData.children

            // 目次エリア印刷可能フラグをtrueに設置
            group1.isTableOfContentsAreaPrintable = true

            // 目次スクロール位置指定用QAIDの位置に目次を移動
            group1.scrollTableOfContentsAreaToCurrentQA()
          }
        })
        .finally(() => {
          group1.isListBookTableOfContentsLoaded = true
        })
    },

    /**
     * 目次スクロール位置指定用QAIDの位置に目次を移動
     */
    scrollTableOfContentsAreaToCurrentQA: () => {

      if (group1.scrollTopQAID !== 0) {

        if (store.state.common.device === 'sp') {
          // SPの場合、対象のQAが存在する階層の目次リストを表示する

          // 対象ノードを取得する
          const treeData = group1.tableOfContentsAreaTreeData 
          const targetId = group1.scrollTopQAID
          const target = {}
          group1.getTargetNode(treeData, targetId, target)
    
          if (target.node && target.node.parent) {
            const parentId = target.node.parent.id
            // 対象データがある階層に目次リストを設定
            group1.changeTableOfContents(parentId)
          }
        }

        // Vue.nextTick()の場合、対象htmlIdを取得できない場合がある。
        // ツリー描画に時間がかかるのではと思われる。
        // そのため、setInterval()でスクロール先要素を取得するまでループする
        let count = 0
        const intervalId = setInterval(() => {
          const htmlId = 'qa_' + group1.scrollTopQAID
          const target = document.getElementById(htmlId)
          if (target) {
            const targetRect = target.getBoundingClientRect()
            let scrollArea = null
            if (store.state.common.device === 'sp') {
              scrollArea = document.getElementById('content-02')
            } else {
              scrollArea = document.getElementById('navi-list')
            }
            if (scrollArea) {
              const areaRect = scrollArea.getBoundingClientRect()
              const scrollY = scrollArea.scrollTop + targetRect.top - areaRect.top - 100
              scrollArea.scrollTop = scrollY
              // 保持していた値をクリア
              group1.scrollTopQAID = 0
              clearInterval(intervalId)
            }
          }
          count++
          if (count >= SCROLL_INTERVAL_MAX_COUNT) {
            clearInterval(intervalId)
          }
        }, SCROLL_INTERVAL_DELAY)
      }
    },

    /**
     * 対象QAIDの存在する箇所以外は全て閉じる
     */
    addExtraParamsToTreeData: (node, parentNode, targetQaId) => {
      if (node.id === 0) {
        node.isOpen = true
      } else {
        // 対象書籍IDの存在する箇所以外は全て閉じる
        node.isOpen = false
      }
      node.parent = parentNode

      // タイトルが改行されている場合は、1行目の文字列と、2行目以降の文字列のリストに分離する
      const title = node.title
      let titleFirstLine = ''
      const titleAfterSecondLines = []
      if (typeof title !== 'undefined') {
        const arr = title.split(/\r?\n/)
        for (let i = 0; i < arr.length; i++) {
          if (i === 0) {
            titleFirstLine = arr[i]
          } else {
            titleAfterSecondLines.push(arr[i])
          }
        }
      }
      node.title_first_line = titleFirstLine
      node.title_after_second_lines = titleAfterSecondLines

      if (node.id === targetQaId) {
        // 対象QAIDを見つけた場合は、それより上の要素のisOpenをtrueにする
        group1.setAllParentElementsOpened(parentNode)
      }

      if (typeof node.children !== 'undefined') {
        for (let i = 0; i < node.children.length; i++) {
          group1.addExtraParamsToTreeData(node.children[i], node, targetQaId)
        }
      }
    },

    /**
     * 対象要素よりも上の階層の要素を全てisOpen=trueに設定する
     */
    setAllParentElementsOpened: (parentNode) => {
      if (parentNode) {
        parentNode.isOpen = true
        if (parentNode.parent) {
          group1.setAllParentElementsOpened(parentNode.parent)
        }
      }
    },

    /**
     * 目次ツリーの対象QAIDの存在するフォルダを開く
     * （あらましから遷移した時に、対象のQAの箇所が開かれハイライト表示できるように）
     */
    openTargetQAOfTreeData: (node, targetQaId) => {

      if (node.id === targetQaId) {
        // 対象QAIDを見つけた場合は、それより上の要素のisOpenをtrueにする
        group1.setAllParentElementsOpened(node.parent)
      }

      if (typeof node.children !== 'undefined') {
        for (let i = 0; i < node.children.length; i++) {
          group1.openTargetQAOfTreeData(node.children[i], targetQaId)
        }
      }
    },

    /**
    * SPページ専用
    * 目次（ドリルダウン）のリストタイトルをクリックした場合
    */
    onListTitleOfTableOfContentsOfSPClicked: () => {
      group1.changeTableOfContents(group1.parentId)
    },

    /**
    * SPページ専用
    * 目次（ドリルダウン）の項目（章・節・QAタイトル）をクリックした場合
    */
    onItemOfTableOfContentsOfSPClicked: (item) => {
      if (typeof item.children !== 'undefined' && item.children.length > 0) {
        // 子要素がある場合 → ドリルダウン
        group1.changeTableOfContents(item.id)
      } else {
        // 子要素が無い場合 → QAタイトルである → QA詳細に遷移
        group1.onQATitleOfTableOfContentsClicked(item.id)
      }
    },

    /**
     * SPページ専用
     * 対象データがある階層に目次リストを設定
     * 
     * 【概要】
     * SPの場合は、ツリーを展開するのではなく、
     * ツリーの要素をクリックすると、ドリルダウン/ドリルアップしていく仕様である。
     * 初期表示で、updateTableOfContentsArea()メソッドで全ツリーを取得し、
     * その後、ツリーの要素をクリックすると、本メソッドが呼び、
     * 目次のリストを更新する(ドリルダウン/ドリルアップする)。
     */
    changeTableOfContents: (targetId) => {

      if (targetId === -1) {
        // トップ階層で、書籍名をクリックした場合は何もしない
        return
      }

      // 対象ノードを取得する
      const treeData = group1.tableOfContentsAreaTreeData 
      const target = {}
      group1.getTargetNode(treeData, targetId, target)

      // 現在の階層の目次リストを設定
      if (typeof target.node.children !== 'undefined') {
        group1.currentTableOfContents = target.node.children
      } else {
        group1.currentTableOfContents = []
      }

      if (!target.node.parent) {
        // トップ階層の場合
        group1.parentId = -1
        group1.currentId = targetId
        group1.currentTitleFirstLine = group1.bookTitle
        group1.currentTitleAfterSecondLines = []
      } else {
        // トップ階層でない場合
        group1.parentId = target.node.parent.id
        group1.currentId = targetId
        group1.currentTitleFirstLine = target.node.title_first_line
        group1.currentTitleAfterSecondLines = target.node.title_after_second_lines
      }
    },

    /**
     * 対象ノードを取得する
     */
    getTargetNode(node, targetId, target) {
      if (node.id === targetId) {
        target.node = node
        return
      }

      if (typeof node.children !== 'undefined') {
        for (let i = 0; i < node.children.length; i++) {
          group1.getTargetNode(node.children[i], targetId, target)
        }
      }
    },

    /**
     * 本文（メインエリア）を更新
     */
    updateMainArea: () => {

      // QA詳細取得APIをコール
      const params = {}
      params.qa_id = store.state.qa.qaId
      params.search_index_id = store.state.qa.searchIndexId

      group1.isMainContentsLoaded = false

      apiQA.detail(params)
        .then(response => {
          if (response) {
            const { data } = response

            group1.type = data.type
            const fileId = data.file_id

            // 設問詳細タイプ
            if (group1.type === 2) {
              // 2:QAの場合

              // PDFのURL
              group1.pdfURLDownload = apiCommon.getFetchFileAPIURL(fileId, true)
              group1.pdfURLStatic = apiCommon.getFetchFileAPIURL(fileId, false)

              // あらまし
              group1.contents = []

            } else if (group1.type === 3) {
              // 3:あらましの場合

              // PDFのURL
              group1.pdfURLDownload = ''
              group1.pdfURLStatic = ''

              // あらまし
              const contentsWork = data.contents ?? []
              for (let i = 0; i < contentsWork.length; i++) {
                const title1 = contentsWork[i].title

                let titleFirstLine1 = ''
                const titleAfterSecondLines1 = []
                if (typeof title1 !== 'undefined') {
                  const arr = title1.split(/\r?\n/)
                  for (let i = 0; i < arr.length; i++) {
                    if (i === 0) {
                      titleFirstLine1 = arr[i]
                    } else {
                      titleAfterSecondLines1.push(arr[i])
                    }
                  }
                }

                contentsWork[i].title_first_line = titleFirstLine1
                contentsWork[i].title_after_second_lines = titleAfterSecondLines1
          
                if (contentsWork[i].contents !== 'undefined') {
                  for (let k = 0; k < contentsWork[i].contents.length; k++) {
                    const title2 = contentsWork[i].contents[k].title

                    let titleFirstLine2 = ''
                    const titleAfterSecondLines2 = []
                    if (typeof title2 !== 'undefined') {
                      const arr = title2.split(/\r?\n/)
                      for (let i = 0; i < arr.length; i++) {
                        if (i === 0) {
                          titleFirstLine2 = arr[i]
                        } else {
                          titleAfterSecondLines2.push(arr[i])
                        }
                      }
                    }

                    contentsWork[i].contents[k].title_first_line = titleFirstLine2
                    contentsWork[i].contents[k].title_after_second_lines = titleAfterSecondLines2
                  }
                }
              }
              group1.contents = contentsWork
            }

            // 関連情報存在フラグ
            group1.relatedInfoExists = data.related_info_exists === 1
            // 内容現在存在フラグ
            group1.relatedContentsExist = data.related_contents_exist === 1
            // 書式ダウンロード存在フラグ
            group1.formDownloadsExist = data.form_downloads_exist === 1
            // 書籍情報表示フラグ
            group1.isAboutBookShown = data.type !== 3
            // QAタイトル
            group1.qaTitle = data.title ?? '-'
            store.dispatch('common/addTitle', group1.qaTitle)

            // 関連情報ウィンドウで使用するQAタイトルを設定
            store.dispatch('qaRelatedInfo/setQaTitle', group1.qaTitle)

            // 印刷タイトルを設定
            store.dispatch('print/setTitle', group1.qaTitle)

            // ブックマークフラグ
            group1.isBookmarked = (data.bookmarks_id !== 0)

            // ブックマークID
            group1.bookmarksId = data.bookmarks_id
            // 追録号数
            group1.manualRecomentation = data.manual_recomentation

            // QAコード
            group1.qaCode = data.qa_code

            // 本文（メインエリア）印刷可能フラグをtrueに設定
            group1.isMainAreaPrintable = true

            // 通常のログイン時のみGTMへログを送信する
            // （アカウントログインやフロントエンドログイン、書籍プレビューはSNH担当者による操作となるので実施しない）
            if (store.state.profile.login_type === 1) {
              // リロードでない
              const prevUrl = location.href
              const prevUrlComp = store.state.qa.prev_url
              store.dispatch('qa/setPrevUrlStr', prevUrl)
              if (store.state.qa.referrer.name !== null || prevUrl !== prevUrlComp) {
                store
                  .dispatch('qa/getQaInfo', group1.qaId)
                  .then(() => {
                    // GTMにログを送信する
                    group1.sendGtmLog(store.state.qa.bookCode, store.state.qa.qaCode, store.state.qa.product_codes)
                  })
              }
            }
          }
        })
        .finally(() => {
          // 設問詳細タイプが「3:あらまし」の場合
          group1.isMainContentsLoaded = true
        })

      // ### QAに紐づくデータを取得 ###

      // 書籍情報ウィンドウ(PCの場合)/書籍スライド(SPの場合)に表示するデータを取得
      // 書籍情報データをロードする
      group1.loadBookInfo()

      // 内容現在ウィンドウ(PCの場合)/内容現在スライド(SPの場合)に表示するデータを取得
      // 現在内容データをロードする
      store.dispatch('qaRelatedInfo/loadCurrentContents')
    },

    /**
     * 書籍情報データをロードする
     */
    loadBookInfo: () => {
      // 書籍情報取得APIをコール
      const bookInfoParams = {}
      bookInfoParams.qa_id = store.state.qa.qaId
      bookInfoParams.search_index_id = store.state.qa.searchIndexId

      apiQA.fetchBookInfo(bookInfoParams)
        .then(response => {
          if (response) {
            const { data } = response

            if (typeof data.author !== 'undefined') {
              group1.book_author = data.author.trim()
            } else {
              group1.book_author = ''
            }
            group1.book_manual_recomentation = data.manual_recomentation
            group1.book_publication_date = data.book_publication_date
          }
        })
    },

    /**
     * 関連情報（右サイドエリア）を更新
     */
    updateBookExampleRelatedArea: () => {

      // 関連情報一覧APIをコール
      const params = {}
      params.qa_id = store.state.qa.qaId
      params.search_index_id = store.state.qa.searchIndexId

      group1.isListBookExampleRelatedInfoLoaded = false

      apiQA.listBookExampleRelatedInfo(params)
        .then(response => {
          if (response) {
            const { data } = response
        
            // 関連法令
            const relatedLaws = data.related_laws ?? []
            for (let i = 0; i < relatedLaws.length; i++) {
              if (relatedLaws[i].flag === 1) {
                relatedLaws[i].relatedInfoTarget = 'LG-001'
              } else if (relatedLaws[i].flag === 2) {
                relatedLaws[i].relatedInfoTarget = 'LG-005'
              } else {
                relatedLaws[i].relatedInfoTarget = ''
              }
              for (let k = 0; k < relatedLaws[i].articles.length; k++) {
                relatedLaws[i].articles[k].relatedInfoTarget = 'LG-003'
              }
            }
            group1.related_laws = relatedLaws

            // 関連通達
            const relatedNotifications = data.related_notifications ?? []
            for (let i = 0; i < relatedNotifications.length; i++) {
              relatedNotifications[i].relatedInfoTarget = 'SNLG-001'
              for (let k = 0; k < relatedNotifications[i].articles.length; k++) {
                relatedNotifications[i].articles[k].relatedInfoTarget = 'SNLG-003'
              }
            }
            group1.related_notifications = relatedNotifications

            // 関連判例
            const relatedPrecedents = data.related_precedents ?? []
            for (let i = 0; i < relatedPrecedents.length; i++) {
              relatedPrecedents[i].relatedInfoTarget = 'CA-001'
            }
            group1.related_precedents = relatedPrecedents

            // 関連裁決
            const relatedDecisions = data.related_decisions ?? []
            for (let i = 0; i < relatedDecisions.length; i++) {
              relatedDecisions[i].relatedInfoTarget = 'DE-001'
            }
            group1.related_decisions = relatedDecisions

            // 関連情報（右サイドエリア）印刷可能フラグをtrueに設定
            group1.isBookExampleRelatedAreaPrintable = true
          }
        })
        .finally(() => {
          group1.isListBookExampleRelatedInfoLoaded = true
        })
    },

    relatedDataExists: computed(() => {
      return (group1.related_laws.length > 0 || 
        group1.related_notifications.length > 0 ||
        group1.related_precedents.length > 0 ||
        group1.related_decisions.length > 0)
    }),

    /**
     * 目次をすべて開く
     * 用途：目次一覧エリアの「すべて開く」ボタン押下時
     */
    openAllTableOfContents: () => {
      const treeData = group1.tableOfContentsAreaTreeData 
      group1.setAllChildrenOpen(treeData, true)
      group1.tableOfContentsAreaTreeData = treeData
    },

    /**
     * 目次を全て閉じる
     * 用途：目次一覧エリアの「すべて閉じる」ボタン押下時
     */
    closeAllTableOfContents: () => {
      const treeData = group1.tableOfContentsAreaTreeData 
      group1.setAllChildrenOpen(treeData, false)
      group1.tableOfContentsAreaTreeData = treeData
    },

    /**
     * 目次の全要素を開く/閉じる
     */
    setAllChildrenOpen: (node, flag) => {
      if (typeof node.children !== 'undefined') {
        const children = node.children
        for (let i = 0; i < children.length; i++) {
          children[i].isOpen = flag
  
          group1.setAllChildrenOpen(children[i], flag)
        }
      }
    },

    /**
     * 目次エリアのQAタイトルがクリックされた場合
     */
    onQATitleOfTableOfContentsClicked: (qaId) => {

      // 目次全画面表示フラグをfalseにして全画面表示をやめる
      group1.isFullSizeNavigation = false

      // QA詳細画面に遷移(URLにQAIDを表示する)
      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPQADetail', params: { qaId: qaId } }).catch(() => {})
        // カルーセルを「本文」に移動
        store.dispatch('qa/setNumberCarouselVisible', 0)
      } else {
        router.push({ name: 'PCQADetail', params: { qaId: qaId } }).catch(() => {})
      }
    },

    /**
     * あらましのタイトルがクリックされた場合
     */
    onTitleOfSummaryClicked: (qaId) => {

      // 目次スクロール位置指定用QAIDを設定
      group1.scrollTopQAID = qaId

      // 目次ツリーの対象QAIDの存在するフォルダを開く
      const treeData = group1.tableOfContentsAreaTreeData 
      group1.openTargetQAOfTreeData(treeData, qaId)
 
      // アドレスバーのURLを変更
      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPQADetail', params: { qaId: qaId } }).catch(() => {})
      } else {
        router.push({ name: 'PCQADetail', params: { qaId: qaId } }).catch(() => {})
      }
    },

    /**
     * 内容現在ウィンドウを表示する
     */
    openCurrentContentsWindow: () => {

      // 関連情報の履歴をクリア
      store.dispatch('qaRelatedInfo/clearHistory')

      // 起動元(current_contents=内容現在、related_info=関連情報)
      const from = 'current_contents'

      const relatedInfoTarget = 'current_contents'
      const relatedInfoKey = ''
      const relatedInfoTitle = '内容現在'

      store.dispatch('qaRelatedInfo/setValues', { from: from, target: relatedInfoTarget, key: relatedInfoKey, title: relatedInfoTitle })

      // 現在内容データをロードする
      store.dispatch('qaRelatedInfo/loadCurrentContents')

      // 関連情報ウィンドウ表示フラグをtrueに設定
      group1.visibleRelatedData = true
    },

    /**
     * 関連情報ウィンドウを表示する
     * @param {string} relatedInfoTarget 対象の関連情報データ連携対象(データ取得するWLJ APIの種類を指定するキー)
     * @param {string} relatedInfoKey 対象の関連情報キー(関連情報・内容現在ページ取得用のキー)
     * @param {string} relatedInfoTitle 対象の関連情報タイトル
     */
    openRelatedInfo: (relatedInfoTarget, relatedInfoKey, relatedInfoTitle) => {
      // 起動元(current_contents=内容現在、related_info=関連情報)
      const from = 'related_info'
      group1.openRelatedInfoWithFrom(relatedInfoTarget, relatedInfoKey, relatedInfoTitle, from)
    },

    /**
     * 関連情報ウィンドウを表示する
     * @param {string} relatedInfoTarget 対象の関連情報データ連携対象(データ取得するWLJ APIの種類を指定するキー)
     * @param {string} relatedInfoKey 対象の関連情報キー(関連情報・内容現在ページ取得用のキー)
     * @param {string} relatedInfoTitle 対象の関連情報タイトル
     * @param {string} from 起動元(current_contents=内容現在、related_info=関連情報)
     */
    openRelatedInfoWithFrom: (relatedInfoTarget, relatedInfoKey, relatedInfoTitle, from) => {
      
      // 関連情報の履歴をクリア
      store.dispatch('qaRelatedInfo/clearHistory')

      store.dispatch('qaRelatedInfo/setValues', { from: from, target: relatedInfoTarget, key: relatedInfoKey, title: relatedInfoTitle })

      // WLJPのデータをロードする
      // ページネーション(prev/next)は存在しないので、chunkNumberは0に設定する
      store.dispatch('qaRelatedInfo/loadWLJPContents', { chunkNumber: 0 })

      // 関連情報ウィンドウ表示フラグをtrueに設定
      group1.visibleRelatedData = true
    },

    /**
     * ブックマークボタン押下時
     */
    onBookmarkButtonClicked: () => {

      if (group1.isBookPreview) {
        // 書籍プレビューの場合は何もしない
        return
      }

      if (group1.isBookmarked) {
        // ブックマーク・後で見る削除APIをコール
        const params = {}
        params.id = group1.bookmarksId // ブックマーク・後で見るID
        params.delete_all = 0 // 全削除フラグ：未指定

        apiBookmark.remove(params)
          .then(response => {
            if (response) {
              const { data } = response

              group1.isBookmarked = !group1.isBookmarked

              store.dispatch('common/showToast', { text: '「' + group1.qaTitle + '」のブックマークを削除しました。' })
            }
          })
      } else {
        // ブックマーク・後で見る追加APIをコール
        const params = {}
        params.type = 1 // 1:ブックマーク
        params.id = store.state.qa.qaId // QA ID
        params.key = 'qa' // qa:QA

        apiBookmark.add(params)
          .then(response => {
            if (response) {
              const { data } = response

              group1.bookmarksId = data.after_id
              group1.isBookmarked = !group1.isBookmarked

              store.dispatch('common/showToast', { text: '「' + group1.qaTitle + '」をブックマークしました。' })
            }
          })
      }

    },

    /**
     * 詳細を別ウィンドウで開く
     */
    openDetailInNewWindow: () => {

      const bookId = store.state.qa.bookId
      const qaId = store.state.qa.qaId
      const bookRevisionId = store.state.qa.bookRevisionId

      // 別ウィンドウにローカルストレージ経由でパラメータを渡す
      const data = {
        bookId: bookId,
        qaId: qaId,
        bookRevisionId: bookRevisionId
      }
      const json = JSON.stringify(data)
      localStorage.setItem(LOCAL_STORAGE_KEY_QA_NEW_WINDOW, json)

      // 別ウィンドウで開く
      if (store.state.common.device === 'sp') {
        window.open('/lc/app/sp/qa-detail/' + qaId, '_blank')
      } else {
        window.open('/lc/app/pc/qa-detail/' + qaId, '_blank')
      }

      return false
    }
  })

  return group1
}
